import Blog from "../classes/blog";

const initBlock = async function( block ) {
	new Blog( block );
};

themeUtils.loadBlock( initBlock, "blog", ".section-blog-content" );
